import { PageHeader } from '@shared/components';
import {
  NavigateBackLink,
  type NavigationTabItem,
  NavigationTabs,
} from '@user-management/components';
import { type Path } from '@user-management/router';

import { useRole } from '../../providers';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'details',
    label: 'Role Details',
    path: '/roles-and-permissions/:appRoleId/details',
  },
  {
    value: 'permissions',
    label: 'Permissions',
    // cast type as Path to avoid type error as this tab should be active when its' any path start with`/roles-and-permissions/:appRoleId/permissions/*`
    path: '/roles-and-permissions/:appRoleId/permissions/*' as Path,
  },
  {
    value: 'users',
    label: 'Users',
    path: '/roles-and-permissions/:appRoleId/users',
  },
];

export default function RolesAndPermissionsPageHeader() {
  const {
    appRoleData: { name },
  } = useRole();

  return (
    <PageHeader
      title={name}
      linkAdornment={
        <NavigateBackLink
          to={{
            pathname: '/roles-and-permissions',
          }}
          label='Back to Roles and Permissions'
          replace
        />
      }
      tabs={<NavigationTabs items={TAB_ITEMS} />}
    />
  );
}
